// First, add this to the imports at the top
import { createEventEmitter } from "./eventEmitter";

// Add this definition before the TOAST_EVENTS
export const GENERIC_TRANSACTION_EVENTS = {
    FAILED: "generic_transaction_failed",
    PENDING: "generic_transaction_pending",
    SUCCESS: "generic_transaction_success",
} as const;

// Define the payload types for generic transactions
export interface GenericTransactionFailedPayload {
    error: Error | string;
    context?: string;
    txHash?: string;
}

export interface GenericTransactionPendingPayload {
    txHash: string;
    message?: string;
}

export interface GenericTransactionSuccessPayload {
    txHash: string;
    message?: string;
}

// Create and export the event emitter
export const genericTransactionEventEmitter = createEventEmitter<{
    [GENERIC_TRANSACTION_EVENTS.FAILED]: GenericTransactionFailedPayload;
    [GENERIC_TRANSACTION_EVENTS.PENDING]: GenericTransactionPendingPayload;
    [GENERIC_TRANSACTION_EVENTS.SUCCESS]: GenericTransactionSuccessPayload;
}>();
